import _, { add, isArray } from 'lodash';
import { 
  getAONDevValueById, 
  getAONProdValueById, 
  getBankDevValueById, 
  getBankProdValueById,
  getVtypeDevValueById,
  getVtypeProdValueById
} from 'api/pipedrive';
import GRAPHQL_API from 'api/graphql';
import { getPricingDetails } from 'components/Quote';
import moment from 'moment';
import logoImg from 'assets/images/MMXLogo_150x150.png';

export const getPAOptions = () => {
  const options = [
    50000,
    100000,
    150000,
    200000,
    250000,
    300000,
    350000,
    400000,
    450000,
    500000,
    550000,
    600000,
    650000,
    700000,
    750000,
    800000,
    850000,
    900000,
    950000,
    1000000
  ]
  return options;
}

export const getDealMapping = (data) => {
  if( !process.env.REACT_APP_PD_STAGE_ENV || process.env.REACT_APP_PD_STAGE_ENV === 'development' ) {
    return dealMappingDev(data);
  }
  return dealMappingProd(data);
}

export const dealMappingDev = (dealData) => {
  if(dealData.success) {
    const data = dealData.data;
    const personDetails = getPersonDetails(data.person_id);
    const make = data['d9405fb2f687049dbbf80542966fe6b6ba442d74'];
    const model = data['4fdbb174917fd2863ff9ad6c56cee24659864207'];
    const year = data['bedd19d5ca9423b832b2488eba489b449b955474'];
    const trim = data['f1fb13c6d0356d3fbe006992b04a731b94ad3d40'];
    const mapping = {
      deal_id: data.id,
      person_id: data.person_id.value,
      person_name: personDetails.name,
      person_emails: flattenPersonEmailsOrPhone(personDetails.emails),
      person_phones: flattenPersonEmailsOrPhone(personDetails.phones),
      user_email: data.user_id.email,
      user_id: data.user_id.id,
      car_brand: make,
      car_model: model,
      car_year: year,
      car_trim: trim,
      vehicle_type: getVtypeDevValueById(data['147c03daefc8a8363be7629a81191369b465551c']),
      bank: getBankDevValueById(data['edca85fcda60368a210be8c19ef09646b7d3504d']),
      aon: getAONDevValueById(data['bcb6c144448a22271ab5d3468def1995f768f3ce']),
      bipd: data['b2c71ce0523241fc4ab47918db4af1a0b8ad3aba'],
      pa: data['fb507d362c2849dbfa8189d9b93f4bb34a2ac530'],
      effective_date: data['81bb008411335d816d7a587cbe30a626c48def32'] ? new Date(data['81bb008411335d816d7a587cbe30a626c48def32']) : null,
      fmv: data['48fa92b30aecc5a19aa270eaf849365df8cf6116'] ? data['48fa92b30aecc5a19aa270eaf849365df8cf6116'] : null,
      deal_fmv: data['48fa92b30aecc5a19aa270eaf849365df8cf6116'] ? data['48fa92b30aecc5a19aa270eaf849365df8cf6116'] : null,
      provider: data['a81b2ba30c3838a75fbce9cccf4d7013bc83a20e']
    }
    return mapping;
  }
  return null;
}

export const getCorrectCoverageAmount = ( amount, tostring = true ) => {
  const finalAmount = Math.round(( amount / 100 ));
  return tostring ? finalAmount.toLocaleString() : finalAmount;
}

const getAddonsPremium = (arr) => {
  let res = 0;
  let prices = [];
  if(arr && !_.isEmpty(arr)) {
    const addOns = Object.keys(arr).forEach((item) => {
      prices.push(getCorrectCoverageAmount(arr[item].price, false))
    })
    res = _.sum(prices)
  }
  return res;
}

export const getSelectedQuotes = (quotes = []) => {
  let str = '';
  quotes.forEach((quote, index) => {
    str += '<li>'
    str += `Provider ${ index + 1 } - ${ quote.product_name } - PHP: ${ getCorrectCoverageAmount(quote.total_premium) }`
    str += '</li>'
  })
  return str;
}

export const getDealNotes = (states) => {
  const markUp = `
    <strong>Quotes Offered:</strong>
    <ul>
      <li>Preferred Provider: ${ states.selected_quotes[0].product_name }</li>
      <li>Total Premium: PHP ${ getCorrectCoverageAmount(states.selected_quotes[0].total_premium) }</li>
      <li>Make: ${ states.car_brand }</li>
      <li>Model: ${ states.car_model }</li>
      <li>Year: ${ states.car_year }</li>
      <li>Variant: ${ states.car_trim }</li>
      <li>BIPD: ${ (states.bipd ? states.bipd : 0).toLocaleString() }</li>
      <li>Vehicle Type: ${ states.vehicle_type.label }</li>
    </ul>
    <ul>
      ${ getSelectedQuotes(states.selected_quotes) }
    </ul>
  `
  return {
    "content": markUp,
    "deal_id": states.deal_id,
    "person_id": states.person_id,
    "user_id": states.user_id
  }
}

export const dealDataDev = (states) => {
  const addOns = getAddonsPremium(states.selected_quotes[0].taxes);
  const provider_id = states.selected_quotes[0].provider_id;
  const provider_name = states.selected_quotes[0].car_insurance[0].general_product[0].provider[0].provider_name;
  const product_id = states.selected_quotes[0].car_insurance[0].title;
  const data = {
    'a81b2ba30c3838a75fbce9cccf4d7013bc83a20e': states.selected_quotes.length ? states.selected_quotes[0].product_name : states.provider,
    'd9405fb2f687049dbbf80542966fe6b6ba442d74': states.car_brand,
    '4fdbb174917fd2863ff9ad6c56cee24659864207': states.car_model,
    'bedd19d5ca9423b832b2488eba489b449b955474': states.car_year,
    'f1fb13c6d0356d3fbe006992b04a731b94ad3d40': states.car_trim,
    '147c03daefc8a8363be7629a81191369b465551c': states.vehicle_type.id,
    'edca85fcda60368a210be8c19ef09646b7d3504d': states.bank ? states.bank.id : null,
    'bcb6c144448a22271ab5d3468def1995f768f3ce': states.aon ? states.aon.id : null,
    'b2c71ce0523241fc4ab47918db4af1a0b8ad3aba': states.bipd, // Bodily Injury
    '41a599cd10a2c93f2575be19164aeb3b39c70d0e': states.bipd, // Property Damage
    'daac8fa16f613433db60f5ceda1f0d448c3fc9ed': states.fmv, // Own Damage | Theft
    'fb507d362c2849dbfa8189d9b93f4bb34a2ac530': states.pa,
    '81bb008411335d816d7a587cbe30a626c48def32': states.effective_date ? moment(states.effective_date).format('YYYY-MM-DD') : null,
    '48fa92b30aecc5a19aa270eaf849365df8cf6116': parseInt( states.fmv ),
    '682bf5474323881acfae451202dcda8ef76252cb': `${ [ states.car_brand, states.car_model, states.car_year, states.car_trim ].join().replace(/\,/g, " ") }`,
    'c716ddbf5ac4de10c4f7dfa70bd20cb2c70b237a': states.selected_quotes.length ? getCorrectCoverageAmount(states.selected_quotes[0].total_premium) : null,
    '970b24dd53312213ce358b13a05b18903633855a': states.selected_quotes.length ? getCorrectCoverageAmount(states.selected_quotes[0].prices.own_damage_theft ? states.selected_quotes[0].prices.own_damage_theft.price : 0) : null,
    'e6cdc7b1f1204f42b4b711179f028ea1884c252e': states.selected_quotes.length ? getCorrectCoverageAmount(states.selected_quotes[0].prices.act_of_nature ? states.selected_quotes[0].prices.act_of_nature.price : 0) : null,
    '98ed41926fc8c687331d2f071934679ae7db410e': states.selected_quotes.length ? addOns : null,
    '2d5606706db84ab836cedbf6adbb5da0b95b768d': states.selected_quotes.length ? getCorrectCoverageAmount(states.selected_quotes[0].deductible ? states.selected_quotes[0].deductible : 0) : null,
    'provider_id': provider_id,
    'provider_name': provider_name,
    'product_id': product_id
  }
  return data;
}

export const dealDataProd = (states) => {
  const addOns = getAddonsPremium(states.selected_quotes[0].taxes);
  const provider_id = states.selected_quotes[0].provider_id;
  const provider_name = states.selected_quotes[0].car_insurance[0].general_product[0].provider[0].provider_name;
  const product_id = states.selected_quotes[0].car_insurance[0].title;
  const data = {
    '9956c547d09a9a4c5ab993b138c8cf55f87f3791': states.selected_quotes.length ? states.selected_quotes[0].product_name : states.provider,
    'c2afc73b6d3a37f7fedcac19260d9da0abfbf814': states.car_brand,
    'abf6c4563cec1cd0592df86ac98b036135258afc': states.car_model,
    'e3d7d5965829012aaa823997209c1d07d01354f3': states.car_year,
    '3d02b0d455612358078d8a04d534c9729da4d3af': states.car_trim,
    'b3ca2d0037c16896740616bf404b9f91e8e168db': states.vehicle_type.id,
    'b1fc5cdde3175c7764a6dd7a09aad57cb6dcaec6': states.bank.id,
    'e603539acae55022a1274f4115fa1b20e52f7a7a': states.aon.id,
    '4bad8307a8fe9f770970cae2fcb5ccf85ddaf2dc': states.bipd, // Bodily Injury
    'a3db5fb078049bd947ae123b71bcc538299c8b32': states.bipd, // Property Damage
    'eb5419fbb28ef54aa27663a9277d789b037cde4a': states.fmv, // Own Damage | Theft
    '18a7465501d273c1851b123fd2bb01023d37cb1a': states.pa,
    '0799cf46216e95d3c7f6bd35b15545f590ee7c33': states.effective_date ? moment(states.effective_date).format('YYYY-MM-DD') : null,
    '1c48ae717fea3d483be879cfc34dc8f239eb9b56': parseInt( states.fmv ),
    '80da798cd870548d8ab64811e20616801c6281a2': `${ [ states.car_brand, states.car_model, states.car_year, states.car_trim ].join().replace(/\,/g, " ") }`,
    'beded656f1a7ea2823d4d331912ce3c8667adbe3': states.selected_quotes.length ? getCorrectCoverageAmount(states.selected_quotes[0].total_premium) : null,
    'dfba18006b6b3efbd7083887cbf5c9ffd83747f6': states.selected_quotes.length ? getCorrectCoverageAmount(states.selected_quotes[0].prices.own_damage_theft ? states.selected_quotes[0].prices.own_damage_theft.price : 0) : null,
    '75c7debdf36263d4f9b737426f31eb35e6f08205': states.selected_quotes.length ? getCorrectCoverageAmount(states.selected_quotes[0].prices.act_of_nature ? states.selected_quotes[0].prices.act_of_nature.price : 0) : null,
    '4969cbeecfa28ecd698b413b0a921cfb45030d09': states.selected_quotes.length ? addOns : null,
    'c6e42c57754678c666b9d3a9221b592602865b70': states.selected_quotes.length ? getCorrectCoverageAmount(states.selected_quotes[0].deductible ? states.selected_quotes[0].deductible : 0) : null,
    'provider_id': provider_id,
    'provider_name': provider_name,
    'product_id': product_id
  }
  return data;
}

export const mapDealDealData = (states) => {
  const data = { person: {}, deal: {}, deal_id: states.deal_id, person_id: states.person_id, notes: '' };
  data.person['phone'] = !_.isEmpty( states.person_phones ) ? states.person_phones.map( ( phone, index ) => {
    if( index === 0 ) {
      return { label: '', value: phone, primary: true }
    }
    return { label: '', value: phone, primary: false }
  }) : null;
  data.person['email'] = !_.isEmpty( states.person_emails ) ? states.person_emails.map( ( email, index ) => {
    if( index === 0 ) {
      return { label: '', value: email, primary: true }
    }
    return { label: '', value: email, primary: false }
  }) : null;

  data.deal = process.env.REACT_APP_PD_STAGE_ENV === 'production' ? dealDataProd(states) : dealDataDev(states);
  data.notes = getDealNotes(states);
  return data;
}

const flattenPersonEmailsOrPhone = (obj) => {
  if(isArray(obj)) {
    return obj.map((email) => {
      return email.value;
    })
  }
  return [];
}

const getCarId = (make, model, year, trim) => {
  const q = `{
    get_car_fair_market_value(brand: "${ make }", model: "${ model }", year: ${ year }, trim: "${ trim }") {
      car_id
    }
  }`
  return GRAPHQL_API.graph(q);
}

export const dealMappingProd = (dealData) => {
  if(dealData.success) {
    const data = dealData.data;
    const personDetails = getPersonDetails(data.person_id);
    const make = data['c2afc73b6d3a37f7fedcac19260d9da0abfbf814'];
    const model = data['abf6c4563cec1cd0592df86ac98b036135258afc'];
    const year = data['e3d7d5965829012aaa823997209c1d07d01354f3'];
    const trim = data['3d02b0d455612358078d8a04d534c9729da4d3af'];
    const mapping = {
      deal_id: data.id,
      person_id: data.person_id.value,
      person_name: personDetails.name,
      person_emails: flattenPersonEmailsOrPhone(personDetails.emails),
      person_phones: flattenPersonEmailsOrPhone(personDetails.phones),
      user_email: data.user_id.email,
      user_id: data.user_id.id,
      car_brand: data['c2afc73b6d3a37f7fedcac19260d9da0abfbf814'],
      car_model: data['abf6c4563cec1cd0592df86ac98b036135258afc'],
      car_year: data['e3d7d5965829012aaa823997209c1d07d01354f3'],
      car_trim: data['3d02b0d455612358078d8a04d534c9729da4d3af'],
      vehicle_type: getVtypeProdValueById(data['b3ca2d0037c16896740616bf404b9f91e8e168db']),
      bank: getBankProdValueById(data['b1fc5cdde3175c7764a6dd7a09aad57cb6dcaec6']),
      aon: getAONProdValueById(data['e603539acae55022a1274f4115fa1b20e52f7a7a']),
      bipd: data['4bad8307a8fe9f770970cae2fcb5ccf85ddaf2dc'],
      pa: data['18a7465501d273c1851b123fd2bb01023d37cb1a'],
      effective_date: data['0799cf46216e95d3c7f6bd35b15545f590ee7c33'],
      fmv: data['1c48ae717fea3d483be879cfc34dc8f239eb9b56'],
      deal_fmv: data['1c48ae717fea3d483be879cfc34dc8f239eb9b56'],
      provider: data['9956c547d09a9a4c5ab993b138c8cf55f87f3791'],
      car_id: getCarId(make, model, year, trim)
    }
    return mapping;
  }
  return null;
}

export const getPersonDetails = (personData) => {
  const result = {
    name: null,
    emails: [],
    phones: []
  }
  if(!_.isEmpty(personData)) {
    result.emails = personData.email.map((email) => {
      return email;
    })
    result.phones = personData.phone.map((phone) => {
      return phone;
    })
    result.name = personData.name;
  }
  return result;
}

export const shuffle = (array) => {
  var m = array.length, t, i;

  // While there remain elements to shuffle…
  while (m) {

    // Pick a remaining element…
    i = Math.floor(Math.random() * m--);

    // And swap it with the current element.
    t = array[m];
    array[m] = array[i];
    array[i] = t;
  }

  return array;
}

// export const getPAPremium
export const getPAPremium = ( rates, vType, usage, productName, coverage ) => {
  const ratesMatch = _.find(rates, [ 'rate_type', vType ]);
  const seatCap = ratesMatch && ratesMatch.personal_accident_seats_covered ?  ratesMatch.personal_accident_seats_covered : null;
  const coveragePerSeat = ratesMatch && ratesMatch.personal_accident_coverage_per_seat ?  ratesMatch.personal_accident_coverage_per_seat : null;
  const costPerSeat = ratesMatch && ratesMatch.personal_accident_cost_per_seat ?  ratesMatch.personal_accident_cost_per_seat : null;
  let premium = 0;

  const seatCapFreeCov = seatCap * coveragePerSeat;
  if( seatCap && coveragePerSeat && costPerSeat ) {
    if( productName === 'SGI Philippines' ) {
      if( coverage < seatCapFreeCov ) {
        premium = 0;
      } 
      if( vType === 'PC1' && ( coverage > seatCapFreeCov ) || vType === 'PC2' && ( seatCap < 7 ) ) {
        premium = 2 * ( coverage - seatCapFreeCov ) / 1000;
      }
      if( vType === 'PC2' && ( seatCap > 7 ) ) {
        premium = seatCap * 100;
      }
      if( usage === 'COMMERCIAL' ) {
        premium = costPerSeat * ( coverage / coveragePerSeat );
      }
    } else {
      if( coverage > seatCapFreeCov ) {
        premium = 2 * (coverage - seatCapFreeCov)/1000
      }
    }
  }
  return premium;
}

export const getPricingAndCoverage = (quoteDataTable) => {
  const prices = quoteDataTable.prices ? quoteDataTable.prices : null;
  const features = quoteDataTable.product_features ? quoteDataTable.product_features[0] : null;
  const ratesMain = quoteDataTable.rates ? quoteDataTable.rates : null;
  const rates = ratesMain ? ratesMain.rates ? ratesMain.rates : null : null;
  const number_of_seats = quoteDataTable.number_of_seats ? quoteDataTable.number_of_seats : null;

  // COVERAGE
  const Riot_Strike = features.riot_strike_and_malicious_damage_coverage ? 'Covered' : 'Not Covered';
  const riot_strike_and_malicious_damage_coverage_short_description = features.riot_strike_and_malicious_damage_coverage_short_description ? features.riot_strike_and_malicious_damage_coverage_short_description : 'Not Covered';
  const acts_of_nature = prices.act_of_nature ? prices.act_of_nature : null;
  const own_damage = prices.own_damage_theft ? prices.own_damage_theft : null;
  const bodily_injury = prices.bodily_injury ? prices.bodily_injury : null;
  const personal_accident = prices.personal_accident ? prices.personal_accident : null;
  const property_damage = prices.property_damage ? prices.property_damage : null;

  const paPremium = getPAPremium( rates, quoteDataTable['car_type'], quoteDataTable['vehicle_type'], quoteDataTable['product_name'], personal_accident ? personal_accident.coverage : null );

  // FEATURES
  let deductible = quoteDataTable.deductible ? `P${ quoteDataTable.deductible.toLocaleString() }` : 'No';
  const findNo_of_Waived_Deductibles = _.find(rates, [ 'rate_type', quoteDataTable['car_type'] ]);
  const No_of_Waived_Deductibles = findNo_of_Waived_Deductibles ? findNo_of_Waived_Deductibles.number_of_waived_deductibles ? parseInt(findNo_of_Waived_Deductibles.number_of_waived_deductibles) : 0 : 0;
  const Number_of_Waived_Deductibles_Short_Description = findNo_of_Waived_Deductibles ? findNo_of_Waived_Deductibles.number_of_waived_deductibles_short_description ? findNo_of_Waived_Deductibles.number_of_waived_deductibles_short_description : 'N/A' : 'N/A';
  const Minor_on_site_repair_shops = features ? features.number_of_accredited_repair_shops ? features.number_of_accredited_repair_shops : 'Not Included' : 'Not Included';
  const Roadside_assistance = features.roadside_assistance ? 'Yes' : 'No';
  const Towing = features.roadside_assistance ? features.roadside_assistance.towing_amount ? `P${ features.roadside_assistance.towing_amount.toLocaleString() }` : 'Not Included' : 'Not Included';
  const Authorized_Repair_Limit = features.authorized_repair_limit ? features.authorized_repair_limit : 0;
  const Years_of_casa_eligibility = features.years_of_casa_eligibility ? features.years_of_casa_eligibility : 0;
  const Alternative_transport = features.roadside_assistance ? features.roadside_assistance.alternative_transport ? 'Yes': 'No' : 'No';
  const Overnight_Accommodation = features.roadside_assistance ? features.roadside_assistance.overnight_accommodation_amount ? `P${ features.roadside_assistance.overnight_accommodation_amount.toLocaleString() }` : 'Not Included' :  'Not Included';
  const Removal_crane_services = features.roadside_assistance ? features.roadside_assistance.vehicle_removal_crane_services_amount ? `P${ features.roadside_assistance.vehicle_removal_crane_services_amount.toLocaleString() }` : 'Not Included' : 'Not Included';  

  const initialCoverageAndPricing = (propsToRemove = null) => {
    const result = {
      Own_Damage: { coverage: own_damage ? `P${ (Math.round(own_damage.coverage / 100)).toLocaleString() }` : 'Not Included', price: own_damage ? `P${ (Math.round(own_damage.price / 100)).toLocaleString() }` : 'N/A' },
      Acts_of_Nature: { coverage: acts_of_nature ? `P${ (acts_of_nature.coverage / 100).toLocaleString() }` : 'Not Included', price: acts_of_nature ? `P${ (acts_of_nature.price / 100).toLocaleString() }` : 'N/A' },
      Bodily_Injury: { coverage: bodily_injury ? `P${ (bodily_injury.coverage / 100).toLocaleString() }` : 'Not Included', price: bodily_injury ? `P${ (bodily_injury.price / 100).toLocaleString() }` : 'N/A' },
      Property_Damage: { coverage: property_damage ? `P${ (property_damage.coverage / 100).toLocaleString() }` : 'Not Included', price: property_damage ? `P${ (property_damage.price / 100).toLocaleString() }` : 'N/A' },
      Personal_Accident: { coverage: personal_accident ? `P${ (personal_accident.coverage).toLocaleString() }` : `P${0}`, price: personal_accident ? `P${ paPremium.toLocaleString() }` : `P${0}` },
      Theft: { coverage: own_damage ? `P${ (Math.round(own_damage.coverage / 100)).toLocaleString() }` : 'Not Included', price: own_damage ? `P${ (Math.round(own_damage.price / 100)).toLocaleString() }` : 'N/A' },
      Riot_Strike: { coverage: Riot_Strike, price: 0 },
      Net_Premium: { coverage: null, price: quoteDataTable.net_premium_final ? `P${ quoteDataTable['net_premium_final'].toLocaleString() }` : `P${0}` },
      "Doc. Stamps": { coverage: null, price: quoteDataTable.document_stamp_tax_price ? `P${ quoteDataTable.document_stamp_tax_price.toLocaleString() }` : `P${0}` },
      "Local Gov.(LGT)": { coverage: null, price: quoteDataTable.local_government_tax_price ? `P${ quoteDataTable.local_government_tax_price.toLocaleString() }` : `P${0}` },
      "VAT": { coverage: null, price: quoteDataTable.vat_price ? `P${ quoteDataTable.vat_price.toLocaleString() }` : `P${0}` }
    }
    if( propsToRemove ) {
      propsToRemove.forEach((prop) => {
        delete result[prop];
      })
    }
    return result;
  }

  const coverageAndPricing = {
    coverageData: initialCoverageAndPricing(['Net_Premium', 'Doc. Stamps', 'Local Gov.(LGT)', 'VAT']),
    featuresData: {
      Deductible: deductible,
      No_of_Waived_Deductibles,
      Towing,
      Authorized_Repair_Limit,
      Years_of_casa_eligibility,
      Minor_on_site_repair_shops,
      Roadside_assistance,
      Alternative_transport,
      Overnight_Accommodation,
      Removal_crane_services
    },
    premiumsData: initialCoverageAndPricing([ 'Theft', 'Riot_Strike' ]),
  }
  return coverageAndPricing;
}

export const Capitalize = (str) => {
  str = str.split(" ");

  for (let i = 0; i < str.length; i++) {
    str[i] = str[i][0].toUpperCase() + str[i].substr(1);
  }
  return str.join(' ');
}

export const getDescription = (value) => {
  let desc = []
  if( typeof value === 'object' ) {
    if( isArray( value ) ) {
      desc = value.map(( q ) => {
        return q
      })
    } else {
      if( !_.isObject( value ) && !_.isEmpty( value ) ) {
        desc = Object.keys(value).map(( q ) => {
          return value[q];
        })
      }
    }
  }
  if( typeof value === 'string' &&  value !== '' ) {
    desc = [ value ];
  }
  return desc;
}

export const getItemDescription = ( item, quote ) => {
  let desc = null;
  switch( item ) {
    case 'Riot,Strike':
      desc = getDescription(quote.product_features[0].riot_strike_and_malicious_damage_coverage_short_description);
    break;
    case 'No_of_Waived_Deductibles':
      const waivedDeductibles = _.find(quote.ratesArray, [ 'rate_type', quote['car_type'] ]);
      if(waivedDeductibles) {
        desc = getDescription(waivedDeductibles.number_of_waived_deductibles_short_description);
      }
    break;
    case 'Towing':
      desc = getDescription(quote.product_features[0].roadside_assistance.towing_short_description);
    break;
    case 'Authorized_Repair_Limit':
      desc = getDescription(quote.product_features[0].authorized_repair_limit_short_description);
    break;
    case 'Alternative_transport':
      desc = getDescription(quote.product_features[0].roadside_assistance.alternative_transport_short_description);
    break;
    case 'Overnight_Accommodation':
      desc = getDescription(quote.product_features[0].roadside_assistance.overnight_accommodation_short_description);
    break;
    case 'Removal_crane_services':
      desc = getDescription(quote.product_features[0].roadside_assistance.vehicle_removal_short_description);
    break;
  }

  return desc;
}

export const mapSelectedQuotesForSendgrid = ( selectedQuotes = [] ) => {
  if( !_.isEmpty( selectedQuotes ) ) {
    const colorThemes = [ '#f6a73a', '#1a517a', '#62b44e' ];
    const quotes = selectedQuotes.map((quote, index) => {

      const car_insurance = quote.car_insurance[0];
      const features = car_insurance.product_features[0];
      const gp = car_insurance.general_product[0];
      const roadside_assistance = car_insurance.product_features[0].roadside_assistance;
      const quoteData = getPricingDetails(quote);
      const ratesArray = quoteData.ratesArray;
      const waivedDeductibles = _.find(ratesArray, [ 'rate_type', quote['car_type'] ]);
      const defaultData = {
        "bg": colorThemes[index],
        "access_to_critical_information": roadside_assistance.access_to_critical_information ? "Yes" : "No",
        "act_of_nature_coverage": quoteData.act_of_nature_coverage === 0 ? 'Not Included' : quoteData.act_of_nature_coverage.toLocaleString(),
        "act_of_nature_price": quoteData.act_of_nature_price !== 0 ? quoteData.act_of_nature_price.toLocaleString() : 'N/A',
        "alternative_transport": roadside_assistance.alternative_transport ? "Yes" : "No",
        "auth_repair_limit": features.authorized_repair_limit ? features.authorized_repair_limit : 0,
        "bodily_injury_coverage": quoteData.bodily_injury_coverage !== 0 ? quoteData.bodily_injury_coverage.toLocaleString() : 'Not Included',
        "bodily_injury_price": quoteData.bodily_injury_price.toLocaleString(),
        "casa_eligibility": features.years_of_casa_eligibility ? features.years_of_casa_eligibility : 0,
        "deductible_fixed": quoteData.deductible.toLocaleString(),
        "document_stamp_tax": quoteData.document_stamp_tax,
        "document_stamp_tax_price": quoteData.document_stamp_tax_price.toLocaleString(),
        "img_url": gp.image.url ? gp.image.url : logoImg,
        "local_government_tax": quoteData.local_government_tax,
        "local_government_tax_price": quoteData.local_government_tax_price.toLocaleString(),
        "minor_onsite_repair_shops": features ? features.number_of_accredited_repair_shops ? features.number_of_accredited_repair_shops : 'Not Included' : 'Not Included',
        "net_premium_final": quoteData.net_premium_final.toLocaleString(),
        "overnight_accommodation": features.roadside_assistance.overnight_accommodation_amount ? features.roadside_assistance.overnight_accommodation_amount : 0,
        "own_damage_theft_coverage": quoteData.own_damage_theft_coverage !== 0 ? quoteData.own_damage_theft_coverage.toLocaleString() : 'Not Included',
        "own_damage_theft_price": quoteData.own_damage_theft_price.toLocaleString(),
        "personal_accident_coverage": quoteData.personal_accident_coverage !== 0 ? quoteData.personal_accident_coverage.toLocaleString() : 'Not Included',
        "personal_accident_price": quoteData.personal_accident_premium.toLocaleString(),
        "property_damage_coverage": quoteData.property_damage_coverage !== 0 ? quoteData.property_damage_coverage.toLocaleString() : 'Not Included',
        "property_damage_price": quoteData.property_damage_price.toLocaleString(),
        "roadside_assistance": features.roadside_assistance ? 'Yes' : 'No',
        "total_premium": quoteData.total_premium.toLocaleString(),
        "towing_amount": features.roadside_assistance ? features.roadside_assistance.towing_amount ? features.roadside_assistance.towing_amount.toLocaleString() : 'Not Included' : 'Not Included',
        "vat_price": quoteData.vat_price.toLocaleString(),
        "vehicle_removal": features.roadside_assistance ? features.roadside_assistance.vehicle_removal_crane_services_amount ? features.roadside_assistance.vehicle_removal_crane_services_amount.toLocaleString() : 'Not Included' : 'Not Included',
        "riotStrike": features.riot_strike_and_malicious_damage_coverage ? 'Covered' : 'Not Covered',
        "waivedDeductibles": waivedDeductibles ? waivedDeductibles.number_of_waived_deductibles ? parseInt(waivedDeductibles.number_of_waived_deductibles) : 0 : 0
      }
      return defaultData;
    })
    return quotes;
  }

  return selectedQuotes;
  
}

export const convertToSendgridEmailObject = ( arrayEmails = [] ) => {

  if( _.isEmpty( arrayEmails ) ) {
    throw new Error( `Invalid customer emails.` );
  }

  const result = arrayEmails.map(( email, index ) => {
    return { email: email }
  })

  return result;
}

export const mapSendgridData = ( states ) => {

  if( !states.selected_quotes || states.selected_quotes.length === 0 ) {
    return null;
  }

  const selectedQuotes = mapSelectedQuotesForSendgrid(states.selected_quotes);
  const data = {
    "subject": `MMX-Ref: (${ states.deal_id }) Moneymax Car Insurance Quote ${ states.person_name ? `- ${ states.person_name }`  : `` }`,
    "replySubject": encodeURIComponent(`Ref: (${ states.deal_id }) Moneymax Car Insurance Quote ${ states.person_name ? `- ${ states.person_name }`  : `` }`),
    "name": `${ states.person_name }`,
    "email": convertToSendgridEmailObject( states.person_emails ? states.person_emails : [] ),
    "deal_id": states.deal_id,
    "pd_deal_email": `${ process.env.REACT_APP_MMX_CI_BCC_EMAIL }${ states.deal_id }@pipedrivemail.com`, // logic here to check for env if dev or prod
    "quoteLength": states.selected_quotes.length,
    "make": states.car_brand,
    "model": states.car_model,
    "year": states.car_year,
    "trim": states.car_trim,
    "fmv": states.fmv.toLocaleString(),
    "userEmail": states.user_email,
    "quotes": selectedQuotes
  }
  return data;
}

export const validateEmail = (email) => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export const hasValidEmails = (emails) => {
  let res = true;
  if( emails && isArray(emails) && !_.isEmpty(emails) ) {
    const check = emails.filter((email) => {
      return validateEmail(email);
    })
    if( _.isEmpty(check) ) {
      res = false;
    }
  } else {
    res = false;
  }
  return res;
}